import { render, staticRenderFns } from "./dialogApprover.vue?vue&type=template&id=96ab2176&scoped=true&lang=pug&"
import script from "./dialogApprover.vue?vue&type=script&lang=js&"
export * from "./dialogApprover.vue?vue&type=script&lang=js&"
import style0 from "./dialogApprover.vue?vue&type=style&index=0&id=96ab2176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ab2176",
  null
  
)

export default component.exports